<script setup lang="ts">
import { menu, MenuItem } from '../../store/menu';

const props = defineProps<{
  navigateInFrame: boolean;
  menuItems: Array<MenuItem>;
}>();

const emit = defineEmits<{ reload: [] }>();

function navigate(event: Event, url: string, newWindow: boolean = false, targetTop: boolean = false) {
  menu.toggle();

  if (!props.navigateInFrame) return;

  // prevent triggering href
  event.preventDefault();

  if (newWindow) {
    window.open(url, '_blank');
    return;
  }

  if (targetTop) {
    window.location.href = url;
    return;
  }

  const iFrame = document.getElementById('menu-iframe');
  if (iFrame) {
    (iFrame as HTMLIFrameElement).src = url;
  }
}
</script>

<template>
  <div v-if="menu.items.length === 0" class="tw-p-1">
    <button @click="emit('reload')" class="button is-light" type="button">
      <FontAwesomeIcon icon="fa-solid fa-redo" />
    </button>
  </div>

  <div v-for="(item, index) in props.menuItems" :key="index" class="nav-list tw-flex tw-w-full tw-px-1">
    <span v-if="item.itemtype === 'divider'" class="nav-header tw-text-white-500 tw-w-full tw-pt-2 tw-uppercase">{{
      item.title
    }}</span>
    <a
      :href="item.url"
      @click="e => navigate(e, item.url, item?.targetnew, item?.targettop)"
      v-else
      class="nav-item tw-mb-1 tw-flex tw-w-full tw-place-content-between tw-rounded-xl tw-px-2 tw-py-2 tw-text-white tw-no-underline">
      <span class="tw-flex tw-min-w-0 tw-items-center">
        <FontAwesomeIcon v-if="item.iconclass" :icon="item.iconclass" class="fa-fw" />
        <span class="tw-ml-3 tw-truncate">{{ item.title }}</span>
      </span>
      <span v-if="item.showbadge">
        <span class="tw-rounded-lg tw-bg-primary tw-p-1">{{ item.badgecontent }}</span>
      </span>
    </a>
  </div>
  <div class="tw-mt-5"></div>
</template>

<style lang="scss" scoped>
.nav-list {
  flex-flow: column wrap;
  z-index: 200;
}
.nav-header {
  padding: 0 1.25em;
  font-size: 0.8em;
  color: var(--primary);
  font-weight: bold;
}

.nav-item {
  font-size: 0.85em;

  &:hover {
    font-weight: 600;
    background: var(--primary);
  }
}
</style>
